import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Actions from '../Actions';
import Button from '../Button';
import Empty from '../Empty';
import FontAwesomeIcon from '../Icon';
import Overlay from '../Overlay';
import Table, { Hidden } from '../Table';
import Search from '../Search';
import { selectSearch } from 'src/store/selectors/search';
import { selectAuthenticatedUser } from 'src/store/selectors/auth';
import AnnouncementForm from '../AnnouncementForm';
import {
  setAnnouncementFormData,
  clearAnnouncementFormData,
} from 'src/store/actions/AnnouncementForm';
import { Link } from 'react-router-dom';
import Announcementsview from '../../pages/Announcements/Announcementsview';
import { convertAnyTimestampToLocal } from 'src/helpers/validationHelper';

const AnnouncementsTable = ({
  announcements,
  onSaveAnnouncements,
  onSearch,
  onDeleteAnnouncement,
}: any) => {
  const [showOverlay, setShowOverlay] = useState(false);
  const [showAnnouncementOverlay, setShowAnnouncementOverlay] = useState(false);
  const [announcementData, setAnnouncementData] = useState({});

  const search = useSelector(selectSearch);
  const user = useSelector(selectAuthenticatedUser);

  const dispatch = useDispatch();

  const handleClearAnnouncementFormData = () => {
    dispatch(clearAnnouncementFormData());
  };

  const handleSetAnnouncementFormData = (data) => {
    dispatch(setAnnouncementFormData(data));
  };

  const canAddAnnouncement =
    user &&
    (user.roles[0].role.name === 'Admin' ||
      user.roles[0].role.name === 'Super Admin' ||
      user.roles[0].role.name === 'Property Developer' ||
      user.roles[0].role.name === 'Strata Manager');

  const canAddAnnouncementEmpty =
    user &&
    (user.roles[0].role.name === 'Admin' ||
      user.roles[0].role.name === 'Super Admin' ||
      user.roles[0].role.name === 'Property Developer');

  const handleAnnouncementClick = (data) => {
    setShowAnnouncementOverlay(true);
    setAnnouncementData(data);
  };

  const handleAddAnnouncementClick = () => {
    setShowOverlay(true);
  };

  const handleAddAnnouncementFromEmpty = () => {
    handleSetAnnouncementFormData({
      title: '',
      description: '',
      propertyId: null,
      attachments: [],
    });
    setShowOverlay(true);
  };

  const handleOverlayClose = () => {
    setShowOverlay(false);
    handleClearAnnouncementFormData();
  };

  const handleAnnouncementOverlayClose = () => {
    setShowAnnouncementOverlay(false);
  };

  const handleDeleteAnnouncement = (data) => {
    if (window.confirm('Are you sure you want to delete Announcement')) {
      onDeleteAnnouncement(data);
    }
  };

  return (
    <>
      <Actions compact>
        <Search
          size="small"
          placeholder="Search Announcements..."
          onChange={onSearch}
          theme={undefined}
        />
        {canAddAnnouncement && (
          <Button
            color="teal"
            label="Add Announcement"
            onClick={handleAddAnnouncementClick}
            icon={
              <FontAwesomeIcon glyph="building" weight="light" size="small" />
            }
            size="small"
          />
        )}
      </Actions>

      {announcements.length > 0 ? (
        <Table
          columns={[
            {
              label: 'Title',
              accessor: 'title',
              sortable: true,
              cell: (data: any) => (
                <Link onClick={() => handleAnnouncementClick(data)}>
                  {data.title}
                </Link>
              ),
            },
            {
              label: 'Property',
              accessor: 'propertyName',
            },
            {
              label: 'Announcement Date',
              cell: (data: any) =>
                convertAnyTimestampToLocal(data.announcementDate),
            },
            {
              cell: (data: any) =>
                user.roles[0].role.name !== 'Realtor' && (
                  <Hidden>
                    {user.roles[0].role.name === 'Home Owner' ? null : (
                      <Button
                        color="semantic"
                        onClick={() => handleDeleteAnnouncement(data)}
                        label={<FontAwesomeIcon glyph="trash" weight="light" />}
                      />
                    )}
                  </Hidden>
                ),
            },
          ]}
          data={announcements}
        />
      ) : (
        <Empty
          direction="ttb"
          headline="No Announcements yet"
          strapline="All Announcements you add will be listed here so it's easier for you to manage."
          searchIsActive={
            search && search.announcements ? search.announcements : ''
          }
          cta={
            canAddAnnouncementEmpty ? (
              <Button
                color="teal"
                label="Add Announcement"
                onClick={handleAddAnnouncementFromEmpty}
                icon={
                  <FontAwesomeIcon
                    glyph="building"
                    weight="light"
                    size="small"
                  />
                }
                size="small"
              />
            ) : null
          }
          image={
            <img
              alt="No Announcements yet"
              src="/assets/empty/properties.svg"
            />
          }
        />
      )}
      <Overlay
        showOverlay={showOverlay}
        content={
          <AnnouncementForm
            onClose={handleOverlayClose}
            onSaveAnnouncements={onSaveAnnouncements}
          />
        }
      />
      <Overlay
        showOverlay={showAnnouncementOverlay}
        content={
          <Announcementsview
            data={announcementData}
            onClose={handleAnnouncementOverlayClose}
          />
        }
      />
    </>
  );
};

export default AnnouncementsTable;
